import { AuthApiError } from '@supabase/supabase-js';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import { supabaseClient } from 'src/auth/supabase';
import { routes } from 'src/constants/routes';

export const useLogoutSupabase = () => {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const queryCache = queryClient.getQueryCache();
    const mutationCache = queryClient.getMutationCache();

    return useMutation<unknown, AuthApiError>({
        mutationKey: ['auth', 'signOut'],
        mutationFn: async () => {
            const res = await supabaseClient.auth.signOut({ scope: 'local' });

            if (res.error) throw res.error;
        },
        onSuccess() {
            navigate(routes.index);
            queryCache.clear();
            mutationCache.clear();
        },
    });
};
